"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentRoutes = void 0;
const component_1 = require("../pages/payment/preview/component");
const backendImport_1 = require("../backendImport");
exports.paymentRoutes = [
    {
        path: '/payment/preview/:id',
        name: 'route.payment.preview'.t(),
        component: component_1.PaymentPreview,
        acl: `${backendImport_1.ACL.aclResources.payment}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: false
    }
];
